module.exports = __webpack_public_path__ + "img/icon_bottom_5.99239860.png";